import { NgModule } from '@angular/core';
import { ObjectRoutingModule } from './object-routing.module';
import { ObjectLogService, ObjectService } from './object.service';

@NgModule({
  imports: [ObjectRoutingModule],
  providers: [ObjectService, ObjectLogService],
})
export class ObjectModule {}
